export const CATEGORIES = [
  "IA Engineer",
  "Machine Learning Engineer",
  "Data Scientist",
  "Data Engineer",
  "Prompt Engineer",
  "AI Automation Specialist",
  "Cybersecurity Analyst",
  "Data Protection Specialist",
  "Cloud Architect",
  "DevOps Engineer",
  "Full Stack Developer",
  "Renewable Energy Engineer",
  "Sustainability Specialist",
  "Bioinformatics Specialist",
  "Biomedical Engineer",
  "Digital Health Specialist",
  "SEO Specialist",
  "Digital Marketing Analyst",
  "E-commerce Manager",
  "Industrial Automation Engineer",
  "IoT Specialist",
  "Robotics Programmer",
  "UX/UI Designer",
  "Video Game Developer",
  "IA Film Maker",
  "IA Designer",
  "IA Trainer",
  "IA Creator",
  "IA Influencer",
  "Content Creator",
  "Influencer",
  "UGC Creator",
  "Social Media Manager",
  "Community Manager",
  "Personal Brand Strategist",
  "Digital Strategist",
  "Growth Hacker",
  "Copywriter",
  "IA Video Editor",
  "Streamer",
  "Online Course Creator",
  "Digital Trainer",
  "Moda",
  "Accesorios",
  "Hogar y Decoración",
  "Belleza y Cuidado Personal",
  "Alimentos y Bebidas",
  "Restaurantes y Cafés",
  "Artesanías",
  "Servicios Profesionales",
  "Educación",
  "Salud y Bienestar",
  "Deportes y Fitness",
  "Juguetería",
  "Mascotas",
  "Viajes y Turismo",
  "Otros"
];

export const MALL_ZONES = [
  { id: "feria_comidas", label: "Feria de Comidas", description: "Restaurantes y gastronomía" },
  { id: "zona_kids", label: "Zona Kids", description: "Tiendas para niños" },
  { id: "boutique", label: "Zona Boutique", description: "Moda exclusiva y diseño" },
  { id: "joyeria", label: "Joyas y Accesorios", description: "Joyerías y relojerías" },
  { id: "zapateria", label: "Calzado", description: "Zapatos y calzado deportivo" },
  { id: "lenceria_hogar", label: "Lencería y Hogar", description: "Ropa interior y hogar" },
  { id: "tecnologia", label: "Zona Tech", description: "Electrónica y gadgets" },
  { id: "belleza", label: "Salud y Belleza", description: "Cuidado personal y estética" },
  { id: "deportes", label: "Zona Deportiva", description: "Ropa y equipo de deportes" },
  { id: "otros", label: "Otras Áreas", description: "Servicios y tiendas varias" }
];

export const ANNOUNCEMENT_CATEGORIES = [
  { id: "empleo", label: "Ofertas de Empleo", icon: "Briefcase" },
  { id: "vivienda", label: "Venta de Viviendas", icon: "Home" },
  { id: "alquiler", label: "Alquiler", icon: "Key" },
  { id: "articulos", label: "Venta de Artículos", icon: "ShoppingBag" },
  { id: "servicios", label: "Servicios Profesionales", icon: "Wrench" },
  { id: "otros", label: "Otros Anuncios", icon: "MoreHorizontal" }
];

export const SHOP_TYPES = [
  { value: "products", label: "Productos" },
  { value: "services", label: "Servicios" },
  { value: "both", label: "Ambos" }
];

export const ORDER_STATUSES = {
  pending: { label: "Pendiente", color: "bg-yellow-100 text-yellow-800" },
  paid: { label: "Pagado", color: "bg-blue-100 text-blue-800" },
  shipped: { label: "Enviado", color: "bg-purple-100 text-purple-800" },
  completed: { label: "Completado", color: "bg-green-100 text-green-800" },
  cancelled: { label: "Cancelado", color: "bg-red-100 text-red-800" }
};

export const COUNTRIES = [
  "España",
  "Colombia",
  "Estados Unidos",
  "México",
  "Argentina",
  "Chile",
  "Perú",
  "Venezuela",
  "Ecuador",
  "Bolivia",
  "Uruguay",
  "Paraguay",
  "Costa Rica",
  "Panamá",
  "Guatemala",
  "Honduras",
  "Nicaragua",
  "El Salvador",
  "Puerto Rico",
  "República Dominicana",
  "Cuba",
  "Canadá",
  "Brasil",
  "Francia",
  "Italia",
  "Alemania",
  "Reino Unido",
  "Portugal",
  "Países Bajos",
  "Suiza"
].sort();

export const PRICING_PLANS = [
  {
    id: "free",
    name: "Gratis",
    price: 0,
    features: [
      "1 Tienda Digital",
      "Hasta 10 Productos/Servicios",
      "1 Curso Online",
      "Catálogo Público",
      "Botón de WhatsApp",
      "Gestión de Pedidos Básica"
    ],
    limits: {
      maxShops: 1,
      maxProducts: 10,
      maxCourses: 1,
      customDomain: false,
      analytics: false
    },
    color: "bg-gray-100",
    buttonText: "Empezar Gratis"
  },
  {
    id: "startup",
    name: "Startup",
    price: 27,
    features: [
      "3 Tiendas Digitales",
      "Hasta 100 Productos/Servicios",
      "5 Cursos Online",
      "Cupones de Descuento",
      "Asistente Virtual (Limitado)",
      "CRM para Clientes"
    ],
    limits: {
      maxShops: 3,
      maxProducts: 100,
      maxCourses: 5,
      customDomain: false,
      analytics: true
    },
    color: "bg-blue-50",
    buttonText: "Elegir Startup"
  },
  {
    id: "webinar",
    name: "Webinar",
    price: 47,
    features: [
      "10 Tiendas Digitales",
      "Hasta 500 Productos/Servicios",
      "20 Cursos Online",
      "Dominio Personalizado",
      "Pasarelas de Pago Directas",
      "Automatizaciones de Venta"
    ],
    limits: {
      maxShops: 10,
      maxProducts: 500,
      maxCourses: 20,
      customDomain: true,
      analytics: true
    },
    color: "bg-purple-50",
    buttonText: "Elegir Webinar"
  },
  {
    id: "unlimited",
    name: "Ilimitado",
    price: 97,
    features: [
      "Tiendas Ilimitadas",
      "Productos Ilimitados",
      "Cursos Online Ilimitados",
      "Todo lo anterior en Ilimitado",
      "Migración Gratuita",
      "Soporte 1-a-1 Directo"
    ],
    limits: {
      maxShops: 9999,
      maxProducts: 9999,
      maxCourses: 9999,
      customDomain: true,
      analytics: true
    },
    color: "bg-orange-50",
    buttonText: "Elegir Ilimitado"
  }
];
